// extracted by mini-css-extract-plugin
module.exports = {"logoutContainer":"logout-button-module__logoutContainer___3djgB","logout":"logout-button-module__logout___2CL00","logoutIcon":"logout-button-module__logoutIcon___1oNEM"};